module.exports = __webpack_public_path__ + "static/media/acc.402ca031.svg";